export type IColorsButtonProps = {
  colors: string[];
};

export const EnumColorsButton = {
  default: '#f5f5f5',
  primary: 'linear-gradient(107deg, #F4FDF7 -2.08%, #E7FFF0 101.25%)',
  secondary: 'linear-gradient(107deg, #F4FFF2 -2.08%, #E1F8DD 101.25%)',
  tertiary: 'linear-gradient(107deg, #FEFFED -2.08%, #F7F9DF 101.25%)',
  quaternary: 'linear-gradient(107deg, #FDF4FF -2.08%, #F3DFF7 101.25%)',
  quinary: 'linear-gradient(107deg, #FEF2F2 -2.08%, #F7E0E0 101.25%)',
  senary: 'linear-gradient(107deg, #F2FFFE -2.08%, #DDF6F8 101.25%)',
  septenary: 'linear-gradient(107deg, #FDF6F4 -2.08%, #FFEDE7 101.25%)',
  octonary: 'linear-gradient(107deg, #F6F7FC -2.08%, #E2E6FC 101.25%)',
  nonary: 'linear-gradient(107deg, #7F7FD5 -2.08%, #91EAE4 99.76%)',
  denary: 'linear-gradient(107deg, #E1EEC3 -2.08%, #F05053 101.25%)',
  undecenary: 'linear-gradient(107deg, #F6D365 -2.08%, #FDA085 99.27%)',
  duodecenary: 'linear-gradient(107deg, #86F8B1 -2.08%, #8FD6EE 101.25%)',
  tredecenary: 'linear-gradient(107deg, #FFEEEE -2.08%, #DDEFBB 101.25%)',
  quattuordecenary: 'linear-gradient(107deg, #FBC992 -2.08%, #D985E4 101.25%)',
  quindecenary: 'linear-gradient(107deg, #93A5CF -2.08%, #E4EFE9 101.25%)',
  sexdecenary: 'linear-gradient(107deg, #E4E4D9 -2.08%, #7DC657 101.25%)',
};
